import React, { useState } from "react";
import { Col, Form, FormGroup, Label, Input } from "reactstrap";
import {
	Container,
	Button,
	Card,
	CardHeader,
	CardActions,
	CardContent,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { useAuth } from "contexts/auth-context";
const Login = (props) => {
	const history = useHistory();
	const [form, setForm] = useState({});
	const { user, login } = useAuth();
	function handleChange(event) {
		const target = event.target;
		const value = target.checked ? target.checked : target.value;
		const name = target.name;
		setForm({
			...form,
			[name]: value,
		});
	}
	function handleSubmit(event) {
		event.preventDefault();
		login(form)
			.then(() => {
				console.log("logged in");
				history.push("/");
			})
			.catch((err) => {
				console.log(err);
				alert(`Login Failed: \n ${err?.message}`);
			});
	}

	return (
		<Container>
			<Form onChange={handleChange}>
				<Card style={{ maxWidth: 600, margin: "auto", marginTop: 16 }}>
					<CardHeader title="Login to City@UMD"></CardHeader>
					<CardContent>
						<FormGroup row>
							<Label for="exampleEmail" xs={12} sm={4}>
								Email
							</Label>
							<Col xs={12} sm={8}>
								<Input type="email" name="email" id="exampleEmail" />
							</Col>
						</FormGroup>
						<FormGroup row>
							<Label for="examplePassword" xs={12} sm={4}>
								Password
							</Label>
							<Col xs={12} sm={8}>
								<Input type="password" name="password" id="examplePassword" />
							</Col>
						</FormGroup>
					</CardContent>
					<CardActions
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Button
							variant="outlined"
							component={Link}
							color="primary"
							to="/user/signup"
							disabled
						>
							SignUp
						</Button>
						<Button onClick={handleSubmit} variant="contained">
							Login
						</Button>
					</CardActions>
				</Card>
			</Form>
		</Container>
	);
};

export default Login;
